import Button from '@/common/components/base/button/Button';
import TextInput from '@/common/components/base/input/textInput/TextInput';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import { ADJUSTER_REPORT_DAMAGED_LINKS } from '@/modules/adjusterReportModules/adjusterReport/links/damaged/damagedLinks';
import { FormValues } from '@/modules/adjusterReportModules/IncidentParticipants/pages/damaged/propertyDamage/images/adjusterImages/otherDamaged/otherDamagedDescription/OtherDamagedDescription.type';
import { getOtherDamagedDescriptionQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getOtherDamagedDescription/getOtherDamagedDescriptionQueryOptions';
import { patchAdjusterOtherDamagedDescriptionQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchAdjusterOtherDamagedDescription/patchAdjusterOtherDamagedDescriptionQueryOptions';
import { useMutation, useQuery } from '@tanstack/react-query';
import { FormProvider, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <OtherDamagedDescription />
    </MainLayout>
  );
};
const OtherDamagedDescription = () => {
  const { damagedId, id } = useParams();
  const navigate = useNavigate();
  const methods = useForm({
    defaultValues: {
      other_damaged_description: '',
    },
  });
  const { mutateAsync } = useMutation(
    patchAdjusterOtherDamagedDescriptionQueryOptions(),
  );
  const { isPending } = useQuery(
    getOtherDamagedDescriptionQueryOptions({
      damagedId: damagedId!,
      id: id!,
      onSuccess: (data) => {
        methods.reset(data);
      },
    }),
  );
  const onSubmit = (data: FormValues) => {
    mutateAsync({
      data: data,
      damagedId: damagedId!,
      id: id!,
    }).then(() => {
      navigate(
        ADJUSTER_REPORT_DAMAGED_LINKS.DAMAGED_IMAGES({
          id: id!,
          damagedId: damagedId!,
        }).ADJUSTER_OTHER_DAMAGED.images,
      );
    });
  };
  if (isPending) {
    return <LoadingPage />;
  }
  return (
    <Box pt="1.5rem">
      <TitleDescription>شرح آسیب‌دیدگی</TitleDescription>
      <Typography color="black-1" my="1.5rem">
        کارشناس محترم، در صورت نیاز می‌توانید شرحی از آسیب‌‌های وارد شده به
        زیان‌دیده ارائه نمایید.
      </Typography>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <TextInput
            placeholder="توضیحات خود را وارد کنید"
            name="other_damaged_description"
            label="توضیحات"
          />
          <FixToBottom className={css({ bottom: 20 })}>
            <Button type="submit" width="100%" marginTop="6px">
              تایید و ادامه
            </Button>
          </FixToBottom>
        </form>
      </FormProvider>
    </Box>
  );
};
